<label for="enderecoBusca">Pesquisa Endereço</label>
<p-autoComplete [suggestions]="suggestions" (completeMethod)="search($event)"
    placeholder="Digite o endereço para efetuar a busca" field="displayAdress" (onSelect)="onSelect($event)"
    (onClear)="limpaBusca()"></p-autoComplete>